import React from 'react';
import PropTypes from 'fe-prop-types';
import { SvgIcon, ChevronLeft, ChevronRight } from 'fe-comp-svg-icon';
import theme from 'fe-appdir-lib-theme';
import NukaCarousel from 'fe-appdir-nuka-carousel';
import {
  CarouselPreviousButton,
  CarouselNextButton,
} from './styled/CarouselButtons';

const PROP_TYPES = {
  children: PropTypes.any.isRequired,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  sixteenByNine: PropTypes.bool,
};

const DEFAULT_PROPS = {
  slidesToShow: null,
  slidesToScroll: null,
  sixteenByNine: false,
}

const Carousel = ({ children, slidesToShow, slidesToScroll, sixteenByNine }) => (
  <NukaCarousel
    renderCenterLeftControls={null}
    renderCenterRightControls={null}
    renderTopLeftControls={({ previousSlide }) => (
      <CarouselPreviousButton onClick={previousSlide}>
        <SvgIcon
          glyph={ChevronLeft}
          fill={theme.colorWhite}
          height={32}
          title="Previous slide"
        />
      </CarouselPreviousButton>
    )}
    renderTopRightControls={({ nextSlide }) => (
      <CarouselNextButton onClick={nextSlide}>
        <SvgIcon
          glyph={ChevronRight}
          fill={theme.colorWhite}
          height={32}
          title="Next slide"
        />
      </CarouselNextButton>
    )}
    renderBottomCenterControls={null}
    cellSpacing={32}
    framePadding="-16"
    easing="easeExpOut"
    edgeEasing="easeBack"
    slidesToShow={slidesToShow ||
      typeof window !== 'undefined' && // needed for SSR
      window.matchMedia('(max-width: 767px)').matches
        ? 1 // Mobile
        : 3 // Desktop
    }
    slidesToScroll={slidesToScroll ||
      typeof window !== 'undefined' && // needed for SSR
      window.matchMedia('(max-width: 767px)').matches
        ? 1 // Mobile
        : 3 // Desktop
    }
    sixteenByNine={sixteenByNine}
  >
    {children}
  </NukaCarousel>
);

Carousel.displayName = 'Carousel';
Carousel.propTypes = PROP_TYPES;
Carousel.defaultProps = DEFAULT_PROPS;

export default Carousel;
